import angular from 'angular';

let fastSearchModule = angular.module('app.catalog.fastSearch', []);

export default fastSearchModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/fast-search/fast-search.js
 **/